import React, { useState } from "react";
import { createPortal } from "react-dom";
import {
  MessageCircle,
  MapPin,
  ChevronDown,
  Menu,
  X,
} from "lucide-react";
import {
  buildWhatsappUrl,
  URL_SISTEMA,
} from "../data/conteudoPorNicho";

export default function Header({ conteudo, onTrocarNicho }) {
  const [drawerAberto, setDrawerAberto] = useState(false);
  const whatsappHref = buildWhatsappUrl(conteudo.hero.mensagemWhatsapp);

  const links = [
    { href: "/#recursos", label: "Recursos" },
    { href: "/#canais", label: "Canais" },
    { href: "/#ivo", label: "Ivo" },
    { href: "/#planos", label: "Planos" },
    { href: "/#faq", label: "FAQ" },
  ];

  return (
    <header
      className="sticky top-0 z-40 bg-[#0A0A0A]/80 backdrop-blur-lg border-b border-white/5"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-[70px] flex items-center justify-between gap-4">
        <a href="/#topo" className="flex items-center" data-testid="header-logo-link">
          <img
            src="/evolzap-logo-horizontal.png"
            alt="Evolzap"
            className="h-7 md:h-8"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-zinc-300 hover:text-white transition-colors"
              data-testid={`nav-link-${l.label}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={onTrocarNicho}
            data-testid="header-trocar-nicho"
            className="hidden md:inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-300 px-3 py-1.5 rounded-lg hover:bg-white/5 transition-colors"
            aria-label="Trocar nicho"
          >
            <MapPin className="w-3.5 h-3.5" />
            <span className="max-w-[140px] truncate">{conteudo.nome}</span>
            <ChevronDown className="w-3.5 h-3.5" />
          </button>

          <a
            href={URL_SISTEMA}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex text-sm text-zinc-300 hover:text-white px-3 py-1.5 transition-colors"
            data-testid="header-entrar"
          >
            Entrar
          </a>

          <a
            href={whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-whatsapp"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-black font-semibold text-sm px-4 py-2 rounded-lg transition-colors shadow-lg shadow-green-500/20"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">Falar no WhatsApp</span>
            <span className="sm:hidden">WhatsApp</span>
          </a>

          <button
            className="lg:hidden text-zinc-300 hover:text-white p-2"
            onClick={() => setDrawerAberto(true)}
            aria-label="Abrir menu"
            data-testid="header-hamburger"
          >
            <Menu className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Mobile drawer (via portal, fora do stacking context do header) */}
      {drawerAberto && createPortal(
        <div
          className="lg:hidden fixed inset-0 z-[9999] backdrop-blur-md animate-fade-in"
          style={{ backgroundColor: "rgba(0,0,0,0.85)" }}
          onClick={() => setDrawerAberto(false)}
        >
          <div
            className="absolute top-0 right-0 w-full max-w-sm h-full border-l border-white/5 p-6 flex flex-col gap-6 overflow-y-auto"
            style={{ backgroundColor: "#0A0A0A" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <img
                src="/evolzap-logo-horizontal.png"
                alt="Evolzap"
                className="h-7"
              />
              <button
                onClick={() => setDrawerAberto(false)}
                className="text-zinc-300 hover:text-white p-2"
                aria-label="Fechar menu"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="flex flex-col gap-1">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setDrawerAberto(false)}
                  className="text-base text-zinc-200 hover:text-white py-3 border-b border-white/5"
                >
                  {l.label}
                </a>
              ))}
            </nav>
            <div className="flex flex-col gap-3 mt-auto">
              <button
                onClick={() => {
                  setDrawerAberto(false);
                  onTrocarNicho();
                }}
                className="inline-flex items-center justify-center gap-2 text-sm text-zinc-300 border border-white/10 hover:bg-white/5 px-4 py-2.5 rounded-lg"
              >
                <MapPin className="w-4 h-4" />
                Trocar nicho ({conteudo.nome})
              </button>
              <a
                href={URL_SISTEMA}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center text-sm text-zinc-300 border border-white/10 hover:bg-white/5 px-4 py-2.5 rounded-lg"
              >
                Entrar no sistema
              </a>
              <a
                href={whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-black font-semibold text-sm px-4 py-3 rounded-lg shadow-lg shadow-green-500/20"
              >
                <MessageCircle className="w-4 h-4" />
                Falar no WhatsApp
              </a>
            </div>
          </div>
        </div>,
        document.body
      )}
    </header>
  );
}
